document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".image_row_image, .arrow-image, .image-row-text");
  targets.forEach(target => {
    target.style.opacity = "0";
  });
  let viewportHeight = window.innerHeight;
  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateVisibility = () => {
    const scrollDown = window.scrollY > lastScrollY;
    lastScrollY = window.scrollY;

    targets.forEach(target => {
      const rect = target.getBoundingClientRect();
      const isVisible = rect.top < viewportHeight && rect.bottom > 0;

      if (isVisible) {
        if (scrollDown || window.scrollY === 0) {
          if (!target.classList.contains("visible-scroll-down")) {
            target.classList.add("visible-scroll-down");
            target.classList.remove("visible-scroll-up");
          }
        } else {
          if (!target.classList.contains("visible-scroll-up")) {
            target.classList.add("visible-scroll-up");
            target.classList.remove("visible-scroll-down");
          }
        }
      } else {
        if (target.classList.contains("visible-scroll-down") || target.classList.contains("visible-scroll-up")) {
          target.classList.remove("visible-scroll-down", "visible-scroll-up");
        }
      }
    });

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateVisibility);
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    viewportHeight = window.innerHeight;
    updateVisibility();
  }, { passive: true });

  // Initial trigger on load
  updateVisibility();
});
